import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n';
import router from './router'
import("@/assets/style/index.less");
import "@/assets/style/var.less";
import { goToRouter } from "@/utils/base";

Vue.prototype.$goToRouter = goToRouter;

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
